import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { pains } from '../../data/content';
export function PainSection() {
  return <section className="py-24 relative" data-id="element-174" data-mp="2wgb52uh6p8q6">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-175" data-mp="2ri9lm8fuj7e6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-176" data-mp="2rkvv4dmarwz1">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-ink mb-8 text-balance" data-id="element-177" data-mp="2cu6c4p2lhdkm">
            ¿Cuántos domingos más vas a perder así?
          </h2>

          <div className="space-y-6 text-lg text-muted text-left md:text-center" data-id="element-178" data-mp="28st72h7bteer">
            <p data-id="element-179" data-mp="23urso9kui39m">Querés comer bien.</p>
            <p data-id="element-180" data-mp="23rnecjdo1r58">
              Pero nadie te dijo que iba a significar llegar al domingo agotado, abrir la
              heladera sin saber qué preparar, cocinar dos cosas que no rinden, y llegar al
              miércoles sin comida lista abriendo la app de delivery que no podés costear.
            </p>
            <p data-id="element-181" data-mp="1ejiq3p1x3mj4">No es falta de voluntad.</p>
            <p className="font-semibold text-ink text-xl" data-id="element-182" data-mp="1ekkcuqsapxgo">Es falta de un sistema.</p>
            <p data-id="element-183" data-mp="zve6miv1j6za">Y mientras no tenés ese sistema, cada semana se ve así:</p>
          </div>
        </motion.div>

        <ul className="space-y-4 mb-20" data-id="element-184" data-mp="14ur2tu7sxqej">
          {pains.map((pain, index) => <motion.li key={pain} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl bg-clay-50 border border-clay-100" data-id="element-185" data-mp="1siqqumdqb2pf" data-mpi={index}>
              <span className="flex-shrink-0 mt-1 text-clay-600" aria-hidden="true" data-id="element-186" data-mp="1nicmbebc6aw5">
                <XIcon size={20} data-id="element-187" data-mp="74e1u5ovxz6k" />
              </span>
              <p className="text-ink/80 leading-relaxed" data-id="element-188" data-mp="c5juk3ijpmg3">{pain}</p>
            </motion.li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="p-8 md:p-10 rounded-3xl bg-surface border border-line mb-16" data-id="element-189" data-mp="2eryz6klm6gv0">
          <h3 className="text-2xl md:text-3xl font-display font-bold text-ink mb-6 text-center" data-id="element-190" data-mp="2501mtaivdiup">
            El problema real no es la receta
          </h3>
          <div className="space-y-4 text-muted leading-relaxed" data-id="element-191" data-mp="1v3ylg6vudo8t">
            <p data-id="element-192" data-mp="1v1ditfnpz4a0">Hay miles de recetas en internet.</p>
            <p data-id="element-193" data-mp="1r1bo5qgejb48">Canales de YouTube, cuentas de Instagram, blogs con miles de ideas.</p>
            <p data-id="element-194" data-mp="1m28l2bjzfeyw">El problema nunca fue la receta.</p>
            <p data-id="element-195" data-mp="1m4v16zkxv2sq">
              El problema es que cada receta existe sola, sin conectarse con las demás, sin
              pensar en la semana completa, sin considerar cuánto rinde, cuánto dura, cómo
              se guarda y cuándo se usa.
            </p>
            <p className="text-ink font-semibold" data-id="element-196" data-mp="3bizv9izyvuc7">Una receta te resuelve una comida.</p>
            <p className="text-pistachio-700 font-semibold text-lg" data-id="element-197" data-mp="3j29337strkz5">
              Un sistema te resuelve la semana.
            </p>
            <p data-id="element-198" data-mp="3nyr53zwrt57s">
              Esa es la diferencia entre seguir improvisando y tener el Mega Pack Cocina
              Lista.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-199" data-mp="1jy2ak2efqxq">
          <p className="text-2xl md:text-3xl font-display font-bold text-pistachio-700 italic" data-id="element-200" data-mp="352rd4p3sm1o7">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </motion.div>
      </div>
    </section>;
}